import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect } from 'omni-common-ui';
import { path as PATH } from './routes';
import { getDefaultSession, getFirstUnitOfSession } from 'data/SessionPlans/accessors';


class Attendance extends PureComponent {
  componentDidMount() {
    this._doRedirectionIfNeeded(this.props);
  }

  componentWillReceiveProps(newProps) {
    this._doRedirectionIfNeeded(newProps);
  }

  _doRedirectionIfNeeded({ defaultSessionId, defaultUnitId, routes, replace, buildRoute }) {
    if (! defaultSessionId || routes[routes.length - 1].path !== PATH) {
      return;
    }
    const url = is.existy(defaultUnitId) ?
      `session/${defaultSessionId}/unit/${defaultUnitId}` :
      `session/${defaultSessionId}/unit/0`;
    replace(buildRoute(url));
  }

  render() {
    return this.props.children || null;
  }
}

Attendance.propTypes = {
  children: PropTypes.node,
  defaultSessionId: PropTypes.string,
};

export function mapStateToProps(state, ownProps) {
  const defaultSessionId = getDefaultSession(state, ownProps.params.groupId).id;
  const defaultUnitId = getFirstUnitOfSession(state, defaultSessionId);
  return { defaultSessionId, defaultUnitId };
}

export default connect(mapStateToProps)(Attendance);



// WEBPACK FOOTER //
// ./containers/Group/Attendance/component.jsx